import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { Buffer } from 'buffer'
import Process from 'process'
import * as Sentry from '@sentry/react'

if (import.meta.env.PROD) {
    Sentry.init({
        dsn: 'https://de6eed5fa00211722eca09695fad5ce8@o114545.ingest.us.sentry.io/4509325564641280',
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
        //   beforeSend (event, hint) {
        //     const error = hint?.originalException

        //     if (error && error instanceof Error && error.message && error.message.match(/Cannot read property 'campaign' of undefined/i)) {
        //       return null
        //     }

        //     if (error && error instanceof Error && error.message && error.message.match(/null is not an object \(evaluating 'i\.emitsOptions'\)/i)) {
        //       return null
        //     }

        //     if (error && error instanceof Error && error.message && error.message.match(/No websocket has been initalied yet/i)) {
        //       return null
        //     }

        //     if (error && error instanceof Error && error.message && error.message.includes('clearRect')) {
        //       return null
        //     }

        //     return event
        //   }
    })

    // Pull from the same getParameters used by our stats module
    // const parameters = getParameters()
    // Sentry.configureScope(function (scope) {
    //   scope.setTag('room', parameters.room)
    //   scope.setTag('server', parameters.server)
    //   scope.setTag('traceId', parameters.trace_id)
    //   scope.setTag('browserId', parameters.browser_id)
    // })
}

import './styles.css'
import { Button, Heading, Icon, Modal, Text, View } from '@fold-dev/core'
import { LogoNew } from './logo.tsx'
import { TbRefresh } from 'react-icons/tb'

globalThis.process = Process
globalThis.Buffer = Buffer

// ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />)

// ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
//     <React.StrictMode>
//         <App />
//     </React.StrictMode>
// )

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <Sentry.ErrorBoundary
        fallback={
            <Modal
                width={500}
                height="fit-content"
                anchor="middle-center"
                onDismiss={() => null}
                isVisible={true}>
                <View
                    p={30}
                    column
                    gap="1rem"
                    width="100%">
                    <LogoNew />
                    <Heading textAlign="center">Whoops...</Heading>
                    <Text
                        textAlign="center"
                        size="lg">
                        Something serious has gone wrong. Our team has been notified, please check back soon.
                    </Text>
                    <Button
                        prefix={<Icon icon={TbRefresh} />}
                        onClick={() => window.location.reload()}>
                        Refresh
                    </Button>
                </View>
            </Modal>
        }>
        <App />
    </Sentry.ErrorBoundary>
)
